import { render, staticRenderFns } from "./TabRank.vue?vue&type=template&id=118c27ce&"
import script from "./TabRank.vue?vue&type=script&lang=js&"
export * from "./TabRank.vue?vue&type=script&lang=js&"
import style0 from "./TabRank.vue?vue&type=style&index=0&id=118c27ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports